<template>
  <v-dialog v-model="show" persistent max-width="450">
    <v-card :loading="busy">
      <v-card-title>Void invoice{{multiple?'s':''}}</v-card-title>
      <v-divider/>
        <v-form>
          <v-container class="mt-2">
            <v-row>
              <v-col>
                Are you sure you want to void the selected invoice{{multiple ? 's' : ''}}?
              </v-col>
            </v-row>
            <v-row class="text-caption">
              <v-col>
                Voiding an invoice sets all amounts and quantities to zero
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="warning" @click="voidInvoice()" :loading="busy">Void</v-btn>
        <v-btn color="primary" @click="show=false;$emit('input',false)">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SalesInvoicesVoid',
  props: {
    invoice: {type:Object, required:false},
    invoices: {type:Array, required:false}
  },
  data() {
    return {
      show: true,
      busy: false
    }
  },
  computed: {
    multiple() {
      return this.invoices.length && !this.invoice;
    }
  },
  methods: {
    async voidInvoice() {
      this.busy = true;
      if (this.multiple) {
        const results = await this.$apiCall(`mutation SalesInvoicesVoid($ids: [ID]!) {
                                                invoicesVoid(ids:$ids) {id,error}
                                              }`,
                                            {ids:this.invoices.map(invoice => invoice.id)});
        this.busy = false;
        if (!results.error) {
          this.show = false;
          const errorCount = results.data.invoicesVoid.length;
          this.$store.commit('setError', {type:errorCount ? 'warning' : 'success',
                                          message:`Voided ${this.invoices.length - errorCount} of ${this.invoices.length} invoices\
                                                    ${errorCount ? `(${errorCount} error${errorCount > 1 ? 's':''})` : ``}`});
          this.$emit('refresh', results.data.invoicesVoid);
          this.$emit('done',false);
        }
      }

      else {
        const results = await this.$apiCall(`mutation SalesInvoicesVoid($id: ID!) {
                                              invoiceVoid(id:$id) {voided,total}
                                              }`,
                                            {id:this.invoice.id});
        this.busy = false;
        if (!results.error) {
          Object.assign(this.invoice, results.invoiceVoid)
          this.show = false;
          this.$emit('done',false);
          this.$store.commit('setError', {type:'success',message:`Voided invoice for ${this.invoice.customerName}`});
        }
      }
    }
  }
}
</script>